import { createGtm } from '@gtm-support/vue-gtm'
import { defineNuxtPlugin, useRouter, useRuntimeConfig } from '#app'
import { useHead, useGtag, useScript } from '#imports'

export default defineNuxtPlugin({
    name: 'google-tag-manager',
    dependsOn: ['dayjs'],
    parallel: true,
    async setup(nuxtApp) {
        const config = useRuntimeConfig()

        if (config.public.gtm.id === 'GTM-XXXXXXXXXX') return

        const gtmOptions = {
            ...config.public.gtm,
            id: config.public.gtm.id,
            enabled: config.public.gtm.id !== 'GTM-XXXXXXXXXX',
            vueRouter: useRouter(),
        }
        // Same-origin switchboard proxy to the sGTM container; the external ssgtm-* domain fails CORS.
        const gtmSrc = `/google-tracking/gtm.js?id=${gtmOptions.id}`

        if (import.meta.server) {
            // No-JS fallback only; the loader runs client-side via onNuxtReady (off the TBT path).
            useHead({
                noscript: [
                    {
                        innerHTML: `<iframe src="${gtmSrc}" height="0" width="0" style="display:none;visibility:hidden"></iframe>`,
                        tagPosition: 'bodyClose',
                        tagPriority: 'low',
                    },
                ],
            })
        }

        if (import.meta.client) {
            // Browser only: on the server it would start user/info before the prefetch plugin.
            const { initGtag } = useGtag()

            // Consent Mode defaults, synchronous, before the container loads.
            // Vitest-skipped: fire-and-forget async that reads user context (useUserInfo)
            // which unit tests don't provide, so its promise would reject unhandled.
            if (!import.meta.env.VITEST) initGtag()

            nuxtApp.vueApp.use(
                createGtm({
                    ...gtmOptions,
                }),
            )

            // Defer off the hydration path (TBT); dataLayer queues until it boots. Vitest-skipped.
            if (!import.meta.env.VITEST) {
                useScript({
                    src: gtmSrc,
                    async: true,
                    defer: true,
                    crossorigin: false, // classic first-party load (useScript defaults crossorigin:'anonymous')
                }, {
                    trigger: 'onNuxtReady',
                })
            }
        }
    }
})
